import { MapPin } from 'lucide-react';
import type { Location } from '~/types';

type AddressSectionProps = {
  title: string;
  address: Location;
};

export function AddressSection({ title, address }: AddressSectionProps) {
  return (
    <div className="bg-neut-bg-alt rounded-lg border border-neut-border p-6 shadow-neut-100">
      <div className="flex items-center gap-2 mb-4">
        <MapPin className="w-5 h-5 text-prim" />
        <h2 className="text-neut-prim font-semibold">{title}</h2>
      </div>
      <div className="p-4 bg-neut-100 rounded-lg">
        <p className="text-sm text-neut-prim font-medium mb-1">
          {address?.name}
        </p>
        <p className="text-xs text-neut-sec">{address?.addressLine1}</p>
        <p className="text-xs text-neut-sec">
          {address?.city}, {address?.region} {address?.zipCode}
        </p>
      </div>
    </div>
  );
}
